import React from 'react';
import { IconProps } from './type';

export const SearchIcon = ({ color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.125 10.375C4.125 6.92322 6.92322 4.125 10.375 4.125C13.8268 4.125 16.625 6.92322 16.625 10.375C16.625 11.8758 16.096 13.253 15.2143 14.3305L20.1919 19.3081C20.436 19.5521 20.436 19.9479 20.1919 20.1919C19.9479 20.436 19.5521 20.436 19.3081 20.1919L14.3305 15.2143C13.253 16.096 11.8758 16.625 10.375 16.625C6.92322 16.625 4.125 13.8268 4.125 10.375ZM10.375 5.375C7.61358 5.375 5.375 7.61358 5.375 10.375C5.375 13.1364 7.61358 15.375 10.375 15.375C13.1364 15.375 15.375 13.1364 15.375 10.375C15.375 7.61358 13.1364 5.375 10.375 5.375Z"
        fill={color}
      />
    </svg>
  );
};
